<opac-user-title
  [title]="'user.holds.title' | translateByCustomerType: customerType.dbValue"
  [skeleton]="(isLoading$ | async) === true"></opac-user-title>

<div class="user-area-wrapper" *ngIf="(isLoading$ | async) === false">
  <opac-no-results *ngIf="!(holds$ | async).length" [label]="'user.holds.noHolds' | translate"> </opac-no-results>

  <app-record-card-grid>
    <app-user-hold-item
      *ngFor="let hold of holds$ | async"
      [hold]="hold"
      [userId]="userService.getUserId()"></app-user-hold-item>
  </app-record-card-grid>
</div>

<ng-container *ngIf="(isLoading$ | async) === true">
  <app-record-card-grid>
    <ng-container *ngFor="let i of [1, 2, 3, 4]; let last = last">
      <card-item-skeleton></card-item-skeleton>
      <opac-skeleton *ngIf="!last" class="hide-tablet" style="height: 1px; margin: 0 -16px"></opac-skeleton>
    </ng-container>
    <opac-gradient></opac-gradient>
  </app-record-card-grid>
</ng-container>
